import {
  PacketModule,
  createPacketServices
} from "./chunk-C72U2L5F.mjs";
import "./chunk-XZSTWKYB.mjs";
export {
  PacketModule,
  createPacketServices
};
